import { render, staticRenderFns } from "./CourseLanding.vue?vue&type=template&id=2138d9e8&scoped=true"
import script from "./CourseLanding.vue?vue&type=script&lang=js"
export * from "./CourseLanding.vue?vue&type=script&lang=js"
import style0 from "./CourseLanding.vue?vue&type=style&index=0&id=2138d9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2138d9e8",
  null
  
)

export default component.exports